/**
 * Merges the provided IDs with a hyphen char.
 * Think of it as emotion's cx() helper but for `id`/ `testid` prop.
 */
export const ix = (...ids) => {
    const [prefix] = ids;
    if (!prefix)
        return;
    return ids.filter((id) => !!id).join('-');
};
//# sourceMappingURL=ix.js.map